<template>
    <div class="bg-F6F7FA">
        <CCol sm="12">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CRow>
                    <CCol sm="3">
                        <CCard class="p-2 custom-bg-card">
                            <img src="../assets/image/IconStatusUp.png" width="40px" />
                            <h3 class="custom-14px-500 font-color-98A2B3">Bayaran Aset</h3>
                            <h2 class="custom-24px-600 text-black">RM 29,435.00</h2>
                            <div class="d-flex">
                                <span class="custom-success custom-12px-600 font-color-12B76A">+0.32%</span><span class="custom-14px-400 font-color-667085 ml-2">Higher than last month</span>
                            </div>
                        </CCard>
                    </CCol>
                    <CCol sm="3">
                        <CCard class="p-2 custom-bg-card">
                            <img src="../assets/image/IconMoney.png" width="40px" />
                            <h3 class="custom-14px-500 font-color-98A2B3">Bekalan</h3>
                            <h2 class="custom-24px-600 text-black">RM 39,435.00</h2>
                            <div class="d-flex">
                                <span class="custom-danger custom-12px-600 font-color-F04438">-0.32%</span><span class="custom-14px-400 font-color-667085 ml-2">Less than last month</span>
                            </div>
                        </CCard>
                    </CCol>
                    <CCol sm="3">
                        <CCard class="p-2 custom-bg-card">
                            <img src="../assets/image/IconCoin.png" width="40px" />
                            <h3 class="custom-14px-500 font-color-98A2B3">Tuntutan kaki tangan</h3>
                            <h2 class="custom-24px-600 text-black">RM 19,435.00</h2>
                            <div class="d-flex">
                                <span class="custom-success custom-12px-600 font-color-12B76A">+0.32%</span><span class="custom-14px-400 font-color-667085 ml-2">Higher than last month</span>
                            </div>
                        </CCard>
                    </CCol>
                    <CCol sm="3">
                        <CCard class="p-2 custom-bg-card">
                            <img src="../assets/image/IconNote.png" width="40px" />
                            <h3 class="custom-14px-500 font-color-98A2B3">Pelajar</h3>
                            <h2 class="custom-24px-600 text-black">RM 9,435.00</h2>
                            <div class="d-flex">
                                <span class="custom-danger custom-12px-600 font-color-F04438">-0.32%</span><span class="custom-14px-400 font-color-667085 ml-2">Less than last month</span>
                            </div>
                        </CCard>
                    </CCol>
                </CRow>
            </CCol>
    
            <CCol sm="12">
                <CRow>
                    <CCol sm="8">
                        <img src="../assets/image/chartbar.png" style="max-width:100%" />
                    </CCol>
                    <CCol sm="4" class="font-color-101828">
                        <CCard class="p-2 custom-bg-card">
                            <vue-cal :events="events" :disable-views="['years', 'year', 'week', 'day']" default-view="month" :locale="customLocale" style="height: 340px" />
                        </CCard>
                    </CCol>
                </CRow>
            </CCol>
    
    
            <CCol sm="12">
                <CCard class="p-2 custom-bg-card">
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="9">
                                <div class="d-flex">
                                    <img src="../assets/image/IconCamera.png" height="36px" /><label class="custom-18px-600 ml-2 mt-2">Summary Table</label>
                                </div>
                            </CCol>
                            <CCol sm="3">
                                <div class="d-flex">
                                    <CInput type="text" class="mr-2" placeholder="Search...."/><img src="../assets/image/IconFilter.png" height="36px" />
                                </div>
                            </CCol>
                        </CRow>
                    </CCol>
    
    
                    <table class="table table-responsive-sm">
                        <thead class="custom-bg-header-table" style="border-bottom:none">
                            <th style="border-radius: 10px var(--radius-none, 0px) var(--radius-none, 0px) 10px;">Bill</th>
                            <th>Pusat</th>
                            <th>Tarikh Terima (Bajet)</th>
                            <th>Tarikh Serahan Ke Unit</th>
                            <th>Tarikh Lulus Baucer</th>
                            <th>Nama Pembekal</th>
                            <th style="border-radius: var(--radius-none, 0px) 10px 10px var(--radius-none, 0px);
background: var(--colors-gray-light-mode-100, #F2F4F7);">Status</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Mara HQ & Mara branch</td>
                                <td>08/11/2024</td>
                                <td>08/11/2024</td>
                                <td>09/11/2024</td>
                                <td>Fazrul Mohd</td>
                                <td>
                                    <span class="custom-warning">Pending</span>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Mara HQ & Mara branch</td>
                                <td>08/11/2024</td>
                                <td>08/11/2024</td>
                                <td>09/11/2024</td>
                                <td>Fazrul Mohd</td>
                                <td>
                                    <span class="custom-success font-color-12B76A">Complete</span>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Mara HQ & Mara branch</td>
                                <td>08/11/2024</td>
                                <td>08/11/2024</td>
                                <td>09/11/2024</td>
                                <td>Fazrul Mohd</td>
                                <td>
                                    <span class="custom-warning">Pending</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
    
                </CCard>
            </CCol>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'

import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';

export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        CChartDoughnut,
        CChartBar,
        VueCal

    },

    data() {
        return {
            
            customLocale: {
                days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], // Abbreviated day names
                months: [
                    'January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'
                ],
                firstDayOfWeek: 1, // Set Monday as the first day of the week
            },
            events: []
        }





    },
    async mounted() {
        // try {
        //     const isAuth = await this.UserAuth();
        //     if (isAuth) {
        //     } else {
        //         this.GoToPage();
        //     }
        // } catch (error) {
        //     this.GoToPage();
        //     console.error("Error during authentication:", error);
        //     // Handle the error here
        // }

    },

    computed: {
        

    },

    methods: {



    }

};
</script>